<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :page.sync="page"
      :data="data"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parktempcarrule_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openSettingForm('', 'add')"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" icon="el-icon-view" @click="openRuleFormView(scope.row)"
          >查看
        </el-button>
        <el-button type="text" size="small" icon="el-icon-edit" @click="openRuleFormEdit(scope.row)"
          >修改
        </el-button>
        <el-button type="text" size="small" icon="el-icon-delete" @click="rowDel(scope.row)"
          >删除
        </el-button>
      </template>
    </avue-crud>
    <fee-rule-setting-form
      ref="feeRuleSettingFormAdd"
      @submit="rowSaveRuls"
      @closeSettingForm="onLoad"
    ></fee-rule-setting-form>
    <fee-rule-setting-form
      ref="feeRuleSettingFormView"
      disabled="true"
      edit="true"
      @submit="rowSaveRuls"
      @closeSettingForm="onLoad"
    ></fee-rule-setting-form>
    <fee-rule-setting-form
      edit="true"
      ref="feeRuleSettingFormEdit"
      @update="rowUpdate"
      @closeSettingForm="onLoad"
    ></fee-rule-setting-form>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/tempcar/parktempcarrule';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import feeRuleSettingForm from '@/views/v4ward/park/tempcar/parkvehicletyperule-form.vue';
export default {
  components: { feeRuleSettingForm },
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      reWrite: false,
      selectionList: [],
      option: {
        height: 'auto',
        //calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 4,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        indexLabel: '序号',
        dialogWidth: '50%',
        labelWidth: 120,
        span: 12,
        columnBtn: false,
        refreshBtn:false,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            editDisabled: true,
            search: true,
            searchSpan: 5,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },

          {
            label: '计费编号',
            prop: 'ruleCode',
            rules: [
              {
                required: true,
                message: '请输入计费编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '计费规则名称',
            prop: 'ruleName',
            rules: [
              {
                required: true,
                message: '请输入计费规则名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车型',
            prop: 'vehicleType',
            type: 'select',
            search: true,
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入车辆类型',
                trigger: 'change',
              },
            ],
          },
          /*{
            label: '按天计费类型: 0 按自然天 1 白天 2 晚上',
            prop: 'dayBillingType',
            rules: [
              {
                required: true,
                message: '请输入按天计费类型: 0 按自然天 1 白天 2 晚上',
                trigger: 'change',
              },
            ],
          },
          {
            label: '白天时间段: 如 07:00-19:00，is_day=1时有值',
            prop: 'dayTimeRange',
            rules: [
              {
                required: true,
                message: '请输入白天时间段: 如 07:00-19:00，is_day=1时有值',
                trigger: 'change',
              },
            ],
          },*/
          {
            label: '免费时长（分钟）',
            prop: 'freeTime',
            rules: [
              {
                required: true,
                message: '请输入免费时长（分钟）',
                trigger: 'change',
              },
              { pattern: /^[+]?\d{1,5}$/, message: '格式错误' },
            ],
          },
          {
            label: '是否包含免费时长',
            prop: 'includeFreeTime',
            type: 'select',
            hide: true,
            dicData: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请输入是否包含免费时长 1是 0否',
                trigger: 'change',
              },
            ],
          },
          {
            label: '免费时长是否循环',
            prop: 'freeTimeLoop',
            type: 'select',
            hide: true,
            dicData: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请输入免费时长是否循环',
                trigger: 'change',
              },
            ],
          },
          {
            label: '单日最高收费(元)',
            prop: 'dayHeightestAmount',
            rules: [
              {
                required: true,
                message: '请输入日最高收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '总金额限额(元)',
            prop: 'totalAmountLimit',
            rules: [
              {
                required: true,
                message: '总金额限额（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '0-1小时',
            prop: 'parkingTime01',
            rules: [
              {
                required: true,
                message: '请输入0到1小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '1-2小时',
            prop: 'parkingTime02',
            rules: [
              {
                required: true,
                message: '请输入1到2小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '2-3小时',
            prop: 'parkingTime03',
            rules: [
              {
                required: true,
                message: '请输入2到3小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '3-4小时',
            prop: 'parkingTime04',
            rules: [
              {
                required: true,
                message: '请输入3到4小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '4-5小时',
            prop: 'parkingTime05',
            rules: [
              {
                required: true,
                message: '请输入4到5小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '5-6小时',
            prop: 'parkingTime06',
            rules: [
              {
                required: true,
                message: '请输入5到6小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '6-7小时',
            prop: 'parkingTime07',
            rules: [
              {
                required: true,
                message: '请输入6到7小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '7-8小时',
            prop: 'parkingTime08',
            rules: [
              {
                required: true,
                message: '请输入7到8小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '8-9小时',
            prop: 'parkingTime09',
            rules: [
              {
                required: true,
                message: '请输入8到9小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '9-10小时',
            prop: 'parkingTime10',
            rules: [
              {
                required: true,
                message: '请输入9到10小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '10-11小时',
            prop: 'parkingTime11',
            rules: [
              {
                required: true,
                message: '请输入10到11小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '11-12小时',
            prop: 'parkingTime12',
            rules: [
              {
                required: true,
                message: '请输入11到12小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '12-13小时',
            prop: 'parkingTime13',
            rules: [
              {
                required: true,
                message: '请输入12到13小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '13-14小时',
            prop: 'parkingTime14',
            rules: [
              {
                required: true,
                message: '请输入13到14小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '14-15小时',
            prop: 'parkingTime15',
            rules: [
              {
                required: true,
                message: '请输入14到15小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '15-16小时',
            prop: 'parkingTime16',
            rules: [
              {
                required: true,
                message: '请输入15到16小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '16-17小时',
            prop: 'parkingTime17',
            rules: [
              {
                required: true,
                message: '请输入16到17小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '17-18小时',
            prop: 'parkingTime18',
            rules: [
              {
                required: true,
                message: '请输入17到18小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '18-19小时',
            prop: 'parkingTime19',
            rules: [
              {
                required: true,
                message: '请输入18到19小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '19-20小时',
            prop: 'parkingTime20',
            rules: [
              {
                required: true,
                message: '请输入19到20小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '20-21小时',
            prop: 'parkingTime21',
            rules: [
              {
                required: true,
                message: '请输入20到21小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '21-22小时',
            prop: 'parkingTime22',
            rules: [
              {
                required: true,
                message: '请输入21到22小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '22-23小时',
            prop: 'parkingTime23',
            rules: [
              {
                required: true,
                message: '请输入22到23小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '23-24小时',
            prop: 'parkingTime24',
            rules: [
              {
                required: true,
                message: '请输入23到24小时内收费（元）',
                trigger: 'change',
              },
            ],
          },
          /*{
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },*/
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parktempcarrule_add, false),
        viewBtn: this.vaildData(this.permission.parktempcarrule_view, false),
        delBtn: this.vaildData(this.permission.parktempcarrule_delete, false),
        editBtn: this.vaildData(this.permission.parktempcarrule_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    // 打开查看页面弹窗
    openRuleFormView(row) {
      this.openSettingForm(row, 'view');
    },
    // 打开修改页面弹窗
    openRuleFormEdit(row) {
      this.openSettingForm(row, 'edit');
    },
    openSettingForm(id, type) {
      let title = '新增收费规则';
      if (type == 'add') {
        title = '新增收费规则';
        this.$refs.feeRuleSettingFormAdd.openDialogForm(title, id);
      } else if (type == 'view') {
        title = '查看收费规则';
        this.$refs.feeRuleSettingFormView.openDialogForm(title, id);
      } else if (type == 'edit') {
        title = '修改收费规则';
        this.$refs.feeRuleSettingFormEdit.openDialogForm(title, id);
      }
    },
    rowSaveRuls(dialogForm) {
      console.log(dialogForm);
      add(dialogForm).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },

    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
